module.exports = __webpack_public_path__ + "img/scissors.2cc59bd4.svg";